import request from "../utils/request";

export function getContactProperty() {
    return request({
        url: `/contactProperty`,
        method: "get",
    });
}

export function createContactProperty(data) {
    return request({
        url: "/contactProperty",
        method: "post",
        data,
    });
}

export function updateContactProperty(id, data) {
    return request.put(`/contactProperty/${id}`, data);
}

export function deleteContactProperty(id) {
    return request.delete(`/contactProperty/${id}`);
}
